<template>
<div class="chapter">
<div class="inner_page">
<a id="page_viii"></a>
<h2 class="fm-title">Abbreviations</h2>
<table>
<tbody><tr>
<td><p class="noindentl"><em class="italic">APC</em></p></td>
<td><p class="noindent"><em class="italic">Acts of the Privy Council</em></p></td>
</tr>
<tr>
<td><p class="noindentl"><em class="italic">Correspondence of Erasmus</em></p></td>
<td><p class="noindent">R.A.B. Mynors, A. Dalzell and J.M. Estes, eds., <em class="italic">The Correspondence of Erasmus: Letters 1356 to 1534</em>, Toronto, University of Toronto Press, 1974 continuing</p></td>
</tr>
<tr>
<td><p class="noindentl"><em class="italic">CSPD</em></p></td>
<td><p class="noindent"><em class="italic">Calendar of State Papers, Domestic</em></p></td>
</tr>
<tr>
<td><p class="noindentl"><em class="italic">CSPVen</em></p></td>
<td><p class="noindent"><em class="italic">Calendar of State Papers, Venetian</em></p></td>
</tr>
<tr>
<td><p class="noindentl">Hall, <em class="italic">Chronicle</em></p></td>
<td><p class="noindent"><em class="italic">The Lives of the Kings. By Edward Hall</em> ed. C. Whibley, 2 vols. London, T.C. and E.C. Jack, 1904</p></td>
</tr>
<tr>
<td><p class="noindentl">L&amp;P</p></td>
<td><p class="noindent"><em class="italic">Letters and Papers, Foreign and Domestic, Henry VIII</em></p></td>
</tr>
<tr>
<td><p class="noindentl">LMA</p></td>
<td><p class="noindent">London Metropolitan Archives</p></td>
</tr>
<tr>
<td><p class="noindentl"><em class="italic">ODNB</em></p></td>
<td><p class="noindent"><em class="italic">Oxford Dictionary of National Biography</em></p></td>
</tr>
<tr>
<td><p class="noindentl">TNA</p></td>
<td><p class="noindent">The National Archives</p></td>
</tr>
<tr>
<td><p class="noindentl">VCH</p></td>
<td><p class="noindent">Victoria History of the Counties of England</p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Abbreviations.vue?7f841790